import { CODE_APP_API_EXPOSED_ROUTE_URL, INBOUND_EMAIL_DOMAIN } from '@/config'
import { useGetProject, useGetRoute } from '@/lib/react-query'

/**
 Hook that returns full URL, or email that can be used to call the route in external systems
 @params projectId, routeId
 @returns Route URL, or email
 */
export const useRouteEntryPoint = (projectId: number, routeId: number) => {
  const project = useGetProject(projectId)
  const route = useGetRoute(projectId, routeId)

  if (route.data?.route.type === 'mail') {
    return `${project.data?.slug}+${route.data?.route.exposedEndpoint}@${INBOUND_EMAIL_DOMAIN}`
  }

  return `${CODE_APP_API_EXPOSED_ROUTE_URL}/${project.data?.slug}/${route.data?.route.exposedEndpoint}`
}
